import React from "react";
import {
 
  AiFillGithub,
  AiFillLinkedin,
  AiFillGoogleCircle,
} from "react-icons/ai";
import { Container, Row } from "react-bootstrap";
import { Col } from "react-bootstrap";
import Zoom from "react-reveal/Zoom";

export default function SocialMedia() {
  return (
    <div className="mt-4">
      <Zoom left cascade>
        <h1> <span style={{color:"#b061df"}}>FIND</span> ME ON</h1>
      </Zoom>
      <Container className="mt-5">
        <Row className="g-2 ">
          
         
          <Col md={4}>
            <a
              href="https://github.com/shivamtpathi"
              target="_blank"
              rel="noreferrer"
              className="icon-colour  home-social-icons"
            >
              <Zoom cascade>
                <AiFillGithub />
              </Zoom>
            </a>
          </Col>
          <Col md={4}>
            <a
              href="https://mail.google.com/mail/u/0/?view=cm&fs=1&tf=1&to=omhishiv@gmail.com&subject=MISSED%20CALL%20EZTRADER&body=Hello%20Shivam%20Tripathi,"
            
              target="_blank"
              rel="noreferrer"
              className="icon-colour  home-social-icons"
            >
              <Zoom cascade>
              <AiFillGoogleCircle />
              </Zoom>
            </a>
          </Col>
          <Col md={4}>
            <a
              href="https://www.linkedin.com/in/shivam-tripathi2000/"
              target="_blank"
              rel="noreferrer"
              className="icon-colour  home-social-icons"
            >
              <Zoom cascade>
              <AiFillLinkedin />
              </Zoom>
            </a>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
